import { createAsyncThunk } from '@reduxjs/toolkit'
import { handleExport } from '../../../../../../helpers/export'
import FinancialAnalysisService from '../../../core/service'

export const getNonBankQuickAssessmentThunk = createAsyncThunk(
  'financialAnalysis/NonBank/getNonBankQuickAssessment',
  async (data, { rejectWithValue }) => {
    const response = await FinancialAnalysisService.getNonBankQuickAssessment(
      data,
    )
    if (response.success) {
      return response.data
    }
    return rejectWithValue(response.errors)
  },
)

export const downloadNonBankQuickAssessment = createAsyncThunk(
  'financialAnalysis/NonBank/downloadNonBankQuickAssessment',
  async (data) => {
    const response =
      await FinancialAnalysisService.downloadNonBankQuickAssessment(data)
    handleExport(response.data, response.filename)
  },
)
